import AppProductQuestionsAndAnswers from './AppProductQuestionsAndAnswers';

export default AppProductQuestionsAndAnswers;
